import GLightbox from 'glightbox'

export function lightbox() {
	const lightbox = GLightbox({
		loop: true,
		touchNavigation: true,
		slideEffect: 'fade',
		autoplayVideos: true,
		videosWidth: '1440px'
	})
}
